import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from "@angular/core";
import { IUniqueModalModel } from "@types-custom/models/ui/modal.model";
import { ModalConfirmationComponent } from "../modal-confirmation/modal-confirmation.component";
import { Icon } from "@types-custom/models/ui/icon-model";
import { ModalService } from "@ui-core/services/modal/modal.service";
import { IGridPageModel } from "@types-custom/models/ui/grid-page-model";
import { ICardPageModel, ITextBuilderModel } from "@types-custom/models/ui/card-page-model";
import { Subscription } from "rxjs";

@Component({
  selector: "sit-cards-page",
  templateUrl: "./cards-page.component.html",
  styleUrls: ["./cards-page.component.scss"],
})
export class CardsPageComponent implements OnInit, OnChanges, OnDestroy{
  @Input() properties!: IGridPageModel;
  @Input() structure!: ICardPageModel;
  @Output("actions") actions = new EventEmitter<{action:string, data:any}>;


  dataCards:any[] = [];


  subscription:Subscription = new Subscription();

  constructor(private modalService:ModalService){

  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  ngOnChanges(changes: SimpleChanges): void {
  }

  ngOnInit(): void {
    this.subscription.add(this.properties.dataSource.data$.subscribe({
      next: (data:any) => {
        this.dataCards = data;
      }
    }))
  }

  changeState(data:any, property:string){
    let dataState = this.getValue(data, property);
    if( dataState == undefined){
      dataState = false;
    }

    if(dataState){
      if(this.structure?.changeState?.inactive.enable){
        const modal: IUniqueModalModel = this.getModal(
          this.structure.changeState.inactive.titleMsg,
          this.structure.changeState.inactive.bodyMsg,
          this.structure.changeState.inactive.icon,
          data,
          property,
          this.structure.changeState.inactive.regex
          )
        setTimeout(() => {
          this.modalService.confirmationModal(modal);
        }, 200);
      }else{
        data[`${property}`] = !data[`${property}`]
        this.onAction({action: 'change_state', data: data});
        this.modalService.cleanModals$.next([]);
      }
    }else{
      if(this.structure?.changeState?.active.enable){
        const modal: IUniqueModalModel = this.getModal(
          this.structure.changeState.active.titleMsg,
          this.structure.changeState.active.bodyMsg,
          this.structure.changeState.active.icon,
          data,
          property,
          this.structure.changeState.active.regex
          )
        setTimeout(() => {
          this.modalService.confirmationModal(modal);
        }, 200);
      }else{
        data[`${property}`] = !data[`${property}`]
        this.onAction({action: 'change_state', data: data});
        this.modalService.cleanModals$.next([]);
      }
    }
  }

  onAction(action:{action:string, data:any}){
    this.actions.emit(action);
  }

  getValue(data:any, property:string){
    var result = data[`${property}`]
    if(Array.isArray(result)){
      result = result.join(", ");
    }
    return result;
  }

  buildText(data:any, builder:ITextBuilderModel){
    var text:string = builder.text;
    builder.params.forEach((param, index) => {
      let regExp = new RegExp(`param${index + 1}`, 'g');
      text = text.replace(regExp, this.getValue(data, param));
    });
    return text;
  }

  getModal(titleMessage: string | undefined, bodyMessage: string | undefined, icon:Icon | undefined, data:any, property:string, regexp: RegExp | undefined){
    let fieldTitle = this.buildText(data, this.structure.body.title);
    if(regexp){
      titleMessage = titleMessage.replace(regexp, fieldTitle);
    }

    return {
      toRender: {
        component: ModalConfirmationComponent,
        data: {
          titleMessage: titleMessage,
          infoMessage: bodyMessage,
          icon: icon
        },
      },
      blockAutoclose: true,
      headerBackgroundClass: 'bg-color-background-4',
      leftLineClass: 'bg-color-state-2',
      sheetBottom: true,
      confirm: () => {
        data[`${property}`] = !data[`${property}`]
        this.onAction({action: 'change_state', data: data});
        this.modalService.cleanModals$.next([]);
      },
      cancel: () => {
        this.dataCards = JSON.parse(JSON.stringify(this.dataCards))
        this.modalService.closeConfirmationModal();
      },
    };
  }
}
